module.exports = __webpack_public_path__ + "static/media/2016_conf_Ideas_Dont_Sell_Themselves.fa4071b8.png";